module.exports = {
  errorMessage: 'Error'
};
